import {createFileRoute} from '@tanstack/react-router';
import {BonusPointShopCartPage} from 'pages/bonus/BonusPointShopCartPage/BonusPointShopCartPage';

export const Route = createFileRoute(
  '/_protected/home/accounts/credits/$accountId/bonus-shop/cart',
)({
  component: BonusPointShopCartPage,
  staticData: {crumbKey: 'navigation.bonus-shop.cart'},
});
